import React from 'react';
import styled from 'styled-components';

const CardWrapper = styled.div`
  width: 33.3%;
  padding: 1%;
`;
const Card = styled.div`
  border-radius: 1%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`;
const CardImage = styled.img`
  border-radius: 1%;
  margin: 0;
  vertical-align: bottom;
`;
const ProgramCard = ({ title, summary, thumbnailUrl, programId }) => {
  return (
    <CardWrapper>
      <a href={'/program/' + programId}>
        <Card>
          <CardImage src={thumbnailUrl} alt={title}/>
        </Card>
      </a>
    </CardWrapper>
  );
};

export default ProgramCard;



// WEBPACK FOOTER //
// ./src/components/Program/ProgramCard.js